import request from '@/utils/request'

const BASE_URL = 'system/user'

export const PAGE_URL = `${BASE_URL}/page`
export const updateProfileUrl = `${BASE_URL}/me/profile`
export const changePasswordUrl = `${BASE_URL}/me/password`
export const userBaseUrl = 'system/user'
export const changeUserPasswordUrl = `${BASE_URL}/password`

export function getMyInfo() {
  return request({
    url: BASE_URL + '/me',
    method: 'get'
  })
}

export function page(query: any) {
  return request({
    url: BASE_URL + '/page',
    method: 'get',
    params: query
  })
}

export function save(data: any) {
  return request({
    url: BASE_URL,
    method: 'post',
    data: data
  })
}

export function get(id: number | string) {
  return request({
    url: BASE_URL + '/' + id,
    method: 'get'
  })
}

export function listProfiles(ids: (string | number)[]) {
  return request({
    url: BASE_URL + '/profiles',
    method: 'get',
    params: {
      userIds: ids.join(',')
    }
  })
}

export function update(data: any) {
  return request({
    url: BASE_URL,
    method: 'put',
    data: data
  })
}

export function changePassword(user: any) {
  return request({
    url: `${BASE_URL}/password`,
    method: 'put',
    data: user
  })
}

export function changeMyPassword(password: any) {
  return request({
    url: `${BASE_URL}/me/password`,
    method: 'put',
    data: password
  })
}

export function updateProfile(user: any) {
  return request({
    url: `${BASE_URL}/me/profile`,
    method: 'put',
    data: user
  })
}

export function remove(idList: number[] | string[]) {
  return request({
    url: BASE_URL,
    method: 'delete',
    data: idList
  })
}
